import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import { MOBILE_MQ, mobileSectionTitleSx } from '../../theme/mobileLayout'

export default function EventDetailHeader({ title, date }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', lg: 'center' },
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: { xs: 3, lg: 4 },
        width: '100%',
        [MOBILE_MQ]: { gap: '24px' },
      }}
    >
      <Typography
        component="h1"
        sx={{
          ...mobileSectionTitleSx,
          width: '100%',
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexShrink: 0,
          flexWrap: 'wrap',
          [MOBILE_MQ]: {
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 18, md: 24 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            whiteSpace: 'nowrap',
          }}
        >
          {date}
        </Typography>
        <PrimaryButton
          to="/contact"
          sx={{
            [MOBILE_MQ]: {
              alignSelf: 'flex-start',
            },
          }}
        >
          Register Now
        </PrimaryButton>
      </Box>
    </Box>
  )
}
